import axios from "axios";
import { REACT_APP_API } from "../constants";
import { requestsFor } from "./headerService";

// Settings → Audit Logs. authnull-service (REACT_APP_API_URL, the same backend
// as databaseService.js) serves POST /api/v1/audit/list: administrators only,
// 403 for anyone else. The org always comes from the session, so orgId is
// never sent; tenantId defaults to the session's tenant.
//
// Full URL on the default axios instance (no baseURL), so local mode's mock
// adapter sees "/api/v1/audit/list" in config.url.
const requests = requestsFor(axios);

const FILTER_KEYS = ["actor", "outcome", "route", "targetType", "targetId", "from", "to"];

export function buildAuditListBody({ page = 1, pageSize = 50, ...filters } = {}) {
  const body = {};
  FILTER_KEYS.forEach((k) => {
    const v = filters[k];
    if (typeof v === "string" ? v.trim() !== "" : v != null) body[k] = typeof v === "string" ? v.trim() : v;
  });
  body.page = Number(page) || 1;
  body.pageSize = Number(pageSize) || 50;
  return body;
}

// → { total, page, pageSize, events }. Rejects with the axios error; callers
// check error.response.status (403 = not an administrator).
export async function listAuditEvents(filters) {
  const { data } = await requests.post(`${REACT_APP_API}/api/v1/audit/list`, buildAuditListBody(filters));
  return {
    total: Number(data && data.total) || 0,
    page: Number(data && data.page) || 1,
    pageSize: Number(data && data.pageSize) || 50,
    events: Array.isArray(data && data.events) ? data.events : [],
  };
}
